import PropTypes from 'prop-types';
import React, {Component, ListView} from 'react';
import SearchSelectListItem from './SearchSelectListItem';

class SearchResult extends Component {
    render () {
        const ListItems = [];
        
        this.props.results.forEach((r, i) => {
            if(this.props.onBeforeItem) {
                const before = this.props.onBeforeItem(r, i, this.props);
                if (before) {
                    ListItems.push(before);
                }
            }
            ListItems.push(this.props.renderItem(
                r,
                this.props.itemProps,
                this.props.searchValue
            ));
        }, this);

        return (
            <div className="searchListResult">{ListItems}</div>
        );
    }
}

SearchResult.propTypes = {
    results: PropTypes.array,
    renderItem: PropTypes.func
};

SearchResult.defaultProps = {
    results: [],
    renderItem: (item, props) => (
        <SearchSelectListItem item={item} {...props}/>
    )
};

export default SearchResult;



// WEBPACK FOOTER //
// ./app/components/SelectLists/SearchResult.jsx